import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { WithCommonProps } from '@types';
import { Icon, IconNames, IconSizes } from '@components/icon';
import { Tooltip, ITooltipProps, useHoverableTooltip } from '@components/tooltip';
export type IconTooltipProps = WithCommonProps<{
  icon: IconNames;
  size?: IconSizes;
  solid?: boolean;
  tooltipId?: string;
} & Omit<ITooltipProps, 'id' | 'reference' | 'isOpen'>>;
export function IconTooltip(t0) {
  const $ = _c(37);
  let children;
  let classNameProp;
  let icon;
  let onClickAway;
  let placement;
  let props;
  let size;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      size,
      icon,
      tooltipId: t1,
      placement,
      onClickAway,
      solid: t2,
      className: classNameProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = classNameProp;
    $[3] = icon;
    $[4] = onClickAway;
    $[5] = placement;
    $[6] = props;
    $[7] = size;
    $[8] = t1;
    $[9] = t2;
  } else {
    children = $[1];
    classNameProp = $[2];
    icon = $[3];
    onClickAway = $[4];
    placement = $[5];
    props = $[6];
    size = $[7];
    t1 = $[8];
    t2 = $[9];
  }
  const tooltipId = t1 === undefined ? "icon-tooltip" : t1;
  const solid = t2 === undefined ? false : t2;
  const {
    triggerProps,
    opened,
    setOpened
  } = useHoverableTooltip();
  const [tooltipElement, setTooltipElement] = React.useState(null);
  let t3;
  if ($[10] !== classNameProp) {
    t3 = twMerge("inline-flex cursor-help", classNameProp);
    $[10] = classNameProp;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  let t5;
  if ($[12] !== setOpened) {
    t4 = () => setOpened(true);
    t5 = () => setOpened(false);
    $[12] = setOpened;
    $[13] = t4;
    $[14] = t5;
  } else {
    t4 = $[13];
    t5 = $[14];
  }
  let t6;
  if ($[15] !== icon || $[16] !== size || $[17] !== solid) {
    t6 = <Icon size={size} name={icon} solid={solid} />;
    $[15] = icon;
    $[16] = size;
    $[17] = solid;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== props || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== tooltipId || $[25] !== triggerProps) {
    t7 = <span className={t3} {...triggerProps} onFocus={t4} onBlur={t5} {...props} ref={setTooltipElement} aria-describedby={tooltipId} tabIndex={0} role="img">{t6}</span>;
    $[19] = props;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = tooltipId;
    $[25] = triggerProps;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== children || $[28] !== onClickAway || $[29] !== opened || $[30] !== placement || $[31] !== tooltipElement || $[32] !== tooltipId) {
    t8 = <Tooltip id={tooltipId} reference={tooltipElement} placement={placement} onClickAway={onClickAway} isOpen={opened} className="whitespace-normal max-w-[400px] z-[10000]">{children}</Tooltip>;
    $[27] = children;
    $[28] = onClickAway;
    $[29] = opened;
    $[30] = placement;
    $[31] = tooltipElement;
    $[32] = tooltipId;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t7 || $[35] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[34] = t7;
    $[35] = t8;
    $[36] = t9;
  } else {
    t9 = $[36];
  }
  return t9;
}